import moment from 'moment'
import { ISharedDiagnosticReport } from '../../../types/diagnostics'
import { Text, View } from '@react-pdf/renderer'
import { styles } from '../styles'
import { useTranslation } from 'react-i18next'

const GeneralInfosBox = ({
  reportData,
}: {
  reportData: ISharedDiagnosticReport
}) => {
  const { t } = useTranslation()

  return (
    <View style={styles.cardContainer}>
      <Text style={[styles.smallText, styles.mediumMb]}>
        {t('sharedDiagnostic.report.addressedToDr')}{' '}
        {reportData?.receiverDoctor?.contactName} {t('shared.common.on')}{' '}
        {moment(reportData.createdAt).format('DD/MM/YYYY')}.
      </Text>
      <View style={styles.flexContainer}>
        <View style={styles.smallWidthContainer}>
          <Text style={[styles.smallText, styles.smallMr, styles.boldText]}>
            {t('sharedDiagnostic.report.patient')}
          </Text>
        </View>
        <View style={styles.largeWidthContainer}>
          <Text style={styles.smallText}>
            {reportData?.patient?.firstName
              ? reportData.patient.firstName.charAt(0).toUpperCase() +
                reportData.patient.firstName.slice(1)
              : null}{' '}
            {reportData.patient?.lastName?.toUpperCase()},{' '}
            {reportData.patient?.gender} {t('sharedDiagnostic.report.bornOn')}{' '}
            {moment(reportData.patient?.dateOfBirth).format('DD/MM/YYYY')},{' '}
            {t('patient.socialSecurityNumberShortLabel')}:{' '}
            {reportData.patient?.socialSecurityNumber}
          </Text>
        </View>
      </View>
      <View style={styles.flexContainer}>
        <View style={styles.smallWidthContainer}>
          <Text style={[styles.smallText, styles.smallMr, styles.boldText]}>
            {t('sharedDiagnostic.report.requesting')}{' '}
          </Text>
        </View>
        <View style={styles.largeWidthContainer}>
          <Text style={styles.smallText}>
            {t('shared.common.dr')} {reportData?.patient?.doctor?.contactName},{' '}
            {t('sharedDiagnostic.report.specialistIn')}{' '}
            {reportData?.patient?.doctor?.specialty?.name},{' '}
            {t('profile.rppsShortLabel')}{' '}
            {reportData?.patient?.doctor?.rppsNumber}
          </Text>
        </View>
      </View>
      <View style={styles.flexContainer}>
        <View style={styles.smallWidthContainer}>
          <Text style={[styles.smallText, styles.smallMr, styles.boldText]}>
            {t('sharedDiagnostic.report.expert')}
          </Text>
        </View>
        <View style={styles.largeWidthContainer}>
          <Text style={styles.smallText}>
            {t('shared.common.dr')} {reportData?.receiverDoctor?.contactName},{' '}
            {t('sharedDiagnostic.report.specialistIn')}{' '}
            {reportData?.receiverDoctor?.specialty?.name},{' '}
            {t('profile.rppsShortLabel')}{' '}
            {reportData?.receiverDoctor?.rppsNumber}
          </Text>
        </View>
      </View>
      <Text style={[styles.extraSmallTextItalic, styles.mediumMt]}>
        {t('sharedDiagnostic.report.generateMsg', {
          date: moment().format('DD/MM/YYYY'),
          time: moment().format('HH:mm'),
        })}
      </Text>
    </View>
  )
}

export default GeneralInfosBox
